<script setup>
const props = defineProps(['size']);
</script>
<template>
    <ProgressSpinner class="spinner_animated" :style="'width:' + props.size + 'px; height:' + props.size + 'px'" strokeWidth="5" fill="var(--surface-ground)" animationDuration="0.6s" aria-label="Loading..." />
</template>
<style>
/* .spinner_animated {
    width: 50px;
    height: 50px;
} */
.spinner_animated .p-progress-spinner-circle {
    stroke: var(--primary-color) !important;
}
</style>
